<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6665 6.83594C14.6665 6.83594 14.6665 7.16927 14.6665 7.83594V9.16927C14.6665 9.83594 14.6665 10.1693 13.6665 10.1693"
      stroke="#292D32"
      stroke-width="1.37143"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.6668 5.83594L5.4068 7.5026C5.1468 7.94927 5.4668 8.5026 5.98013 8.5026H7.51346C8.0268 8.5026 8.3468 9.05594 8.09346 9.5026L6.6668 11.1693"
      stroke="#292D32"
      stroke-width="1.37143"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.66683 13.1693C2.00016 13.1693 1.3335 12.5026 1.3335 9.83594V7.16927C1.3335 4.5026 2.00016 3.83594 4.66683 3.83594"
      stroke="#292D32"
      stroke-width="1.37143"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.6665 3.83594C11.3332 3.83594 11.9998 4.5026 11.9998 7.16927V9.83594C11.9998 12.5026 11.3332 13.1693 8.6665 13.1693"
      stroke="#292D32"
      stroke-width="1.37143"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>